import { proxyFetch } from '@ps/functions/utils/proxyFetch';

/** Remove the current viewer's like from a post, via the server-side posts proxy. */
export async function unlikePost(
  sellerId: string,
  postId: string,
): Promise<void> {
  await proxyFetch('/api/bio/posts/like', {
    method: 'DELETE',
    body: { storeId: sellerId, postId },
  });
}
